import { GlobalAppState } from 'rdx/state';

export const selectNotification = (state: GlobalAppState) => state.notifications.notification;
